export enum TransitionState {
	Enter = 'Enter',
	Exit = 'Exit',
	None = 'None',
}
